import React, { Fragment, useState, useEffect } from 'react';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import {
    Card,
    CardBody,
    Container
} from "reactstrap";
import { Col, Row } from "react-bootstrap";
import CommonHeaderContent from '../../Common/CommonHeaderContent';
import { graphChartSampleData } from './Constants';
import { getGraphChartContent } from '../../Common/Appcommon';
import greenTick from "././assets/img/green_tick_sq.png";

const GraphChartModal = (props) => {
    let { isModalOpen, closeModal, openChartConfig, graphChartType } = props;
    let chartItems = graphChartSampleData;
    return (
        <Modal isOpen={isModalOpen} className={"graph-chart-modal le-modal-lg campaign-modal"}>
            <ModalBody>
                <Fragment>
                    <CommonHeaderContent
                        isModal={true}
                        closeModal={closeModal}
                        buttonTxt={""}
                        headerTitle={"Choose Chart Type"}
                        isClassNeeded={false}
                        mainContent={
                            <div className='mt-3 mb-3'>
                                <Row className='m-0'>
                                    {
                                        Object.keys(chartItems).map((chartType, index) => {
                                            let chartInfo = chartItems[chartType];
                                            let dashboardType = chartInfo['type'];
                                            let dbType = chartInfo['dbtype'];
                                            let data = chartInfo['data'][0];
                                            let name = chartInfo['name'];
                                            let chartBodyContent = getGraphChartContent(chartInfo, index);
                                            if (chartBodyContent !== "") {
                                                return (
                                                    <>
                                                        <Col md="4" className='mb-2 cursor-pointer' onClick={(e) => { openChartConfig(chartType) }}>
                                                            <Card className="main-card border">
                                                                <CardBody>
                                                                    {graphChartType === chartType && <span className='pd-chart-triangle'>
                                                                        <img className='pd-chat-img-selected' src={greenTick} />
                                                                    </span>
                                                                    }
                                                                    <div className="scrollable-content graph-sample-panel">
                                                                        {chartBodyContent}
                                                                    </div>
                                                                </CardBody>
                                                            </Card>
                                                            <div className='text-center mt-2'><span>{name}</span></div>
                                                        </Col>

                                                    </>
                                                )
                                            }
                                        })
                                    }
                                </Row>
                            </div>
                        } />
                </Fragment>
            </ModalBody>
        </Modal>
    )
}

export default GraphChartModal;